import {
    FC,
    useCallback,
    useEffect,
    useMemo, useRef,
    useState
  } from 'react'
  import {
    TagsSearchModalContainer,
    TagsSearchModalWrapper,
    ModalButton,
    ModalText,
    RingWrapper
  } from './styles'
  import { API, Card, PageModel } from '@brg/api'
  import { useProfile } from '@brg/auth'
  import { Colors, FlexBox } from '@brg/ui'
  import {NoProjectWrapper} from "./styles";
  import urlApi from 'shared/actions/urlApi'
  import { useTranslation } from 'react-i18next'
  import { Pagination } from 'shared/components/pagination'
  import { ProjectSearchBarSorting } from 'shared/components/projectsSearchBar/components/projectSearchBarSorting'
  import { CompleteTitle } from '../sendProjects/employStyles'
  import { ProjectsCount } from 'shared/pages/ModeratePages/styles'
  import { ShopCard } from 'shared/pages/Shop/ShopCard'
  import { ProjectsGridNew } from 'shared/components/grids'
  import { ModalSearchWrapper } from '../sendProjects/styles'
  import MobileSearchBar from 'shared/components/MobileSearchBar/MobileSearchBar'
  import { SelectRing } from 'shared/components/projectCard/projectCardNew'
import EmptyModal from './EmptyModal'
import project from 'shared/pages/project'
import UsedInProjectModal from './UsedInProjectModal'
  
  export const useGetCalendars = (
    profileId: string | undefined,
    page: number
  ) => {
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<any>(false)
    const [usedCalendarsData, setUsedCalendarsDate] = useState<any>([])
  
    useEffect(() => {
      if (profileId) {
        urlApi()
          //возвращает проекты, в которых прикреплены календари
          .getUsedCalendarIds()
          .then((r) => {
            setUsedCalendarsDate(r)
          })
      }
    }, [profileId])

    useEffect(() => {
      if (profileId) {
        setLoading(true)
            urlApi()
              .getUserCalendars(page, profileId)
              .then((r) => {
                setData(r)
              })
              .finally(() => setLoading(false))
      }
    }, [profileId, page])
  
    return { data, loading, usedCalendarsData }
  }
  
  interface CalendarsSelectModalProps {
    cardIds: any[]
    projectId: string
    onSubmit: (cards: any[]) => void
  }
  
  const CalendarsSelectModal: FC<CalendarsSelectModalProps> = ({
    onSubmit,
    cardIds,
    projectId
  }) => {
    const { i18n } = useTranslation()
    const [selectedCards, setSelectedCards] = useState<any[]>(cardIds || [])
    const [sorting, setSorting] = useState(1)
    const profile = useProfile();
    const { t } = useTranslation();
    const buttonDisabled = !selectedCards?.length || selectedCards?.length !== 1
    const [currentPage, setPage] = useState(1)
    const [searchText, setSearchText] = useState('');
    const scrollRef = useRef<HTMLDivElement>(null)

    const [showAlreadyUsedModal, setShowAlreadyUsedModal] = useState(false)
  
    const scrollTop = () => {
      if (!scrollRef.current) return
      scrollRef.current?.scrollTo(0, 0)
    }
  
    const onClick = useCallback(
      (cardId: string, selected: boolean) => {
       
        if (selected) {
          setSelectedCards(selectedCards.filter((item) => item !== cardId))
          return
        }
        
        setSelectedCards([cardId])
      },
      [selectedCards]
    )
  
    useEffect(() => {
      if (cardIds?.length) {
        setSelectedCards(cardIds)
      }
    } , [cardIds])
  
    const { data, loading, usedCalendarsData } = useGetCalendars(profile?.accountId, currentPage)
  
    const searchInput = useMemo(() => (
      <ModalSearchWrapper 
        width={'100%'} 
        offsetBottom={24} 
        offsetBottomMobile={16}
      >
        <MobileSearchBar 
          placeholder={t('project_edit.modal.calendar.search_placeholder')} 
          onCustomSearch={(data: string) => setSearchText(data)} 
        />
      </ModalSearchWrapper>
  ), [t])
  
    const cards: any[] = useMemo(() => {
      if (data?.data?.length) {
        return data?.data?.map((card: any) => {
          const projectWithCalendar = usedCalendarsData.find((project: any) => {
            return project.includedCalendarIds?.includes(card.cardId)
          })
          return API.toLang({...card, usedInProjectName: (projectWithCalendar?.title || '')}, i18n.language)
        })
      }
  
      return []
    } , [data, i18n, usedCalendarsData])
  
    const handleAttachClick = useCallback(() => {
      const calendarsUsedInProjects = selectedCards.filter((selectedCardsId: any) => {
        return !!usedCalendarsData.find((project: any) => {
          return project.includedCalendarIds?.includes(selectedCardsId)
        })
      })
      // return
      if (!buttonDisabled) {
        if (calendarsUsedInProjects.length) {
          setShowAlreadyUsedModal(true)
          return
        }
        onSubmit(selectedCards)
      }
    }, [selectedCards, usedCalendarsData])

    const cancelAttachment = useCallback(() => {
      setShowAlreadyUsedModal(false)
    }, [])

    const continueAttachment = useCallback(() => {
      onSubmit(selectedCards)
      setShowAlreadyUsedModal(false)
    }, [selectedCards])
  
    return (
      <TagsSearchModalWrapper autoScroll>
        <TagsSearchModalContainer>
          <FlexBox width={'100%'} widthMobile={'100%'} style={{ position: 'relative' }} justify='space-between' justifyMobile='space-between' direction='row' directionMobile="row">
            <FlexBox width={'100%'} widthMobile={'100%'} justify='space-between' align='center' offsetBottom={48}>
              <CompleteTitle>
                {t('project_edit.modal.calendar.main_title')}
              </CompleteTitle>
              <ModalButton
                onClick={handleAttachClick}
                fill={Colors.galBlack100}
                disabled={!Boolean(selectedCards?.length)}
                width={250}
              >
                {t('project_edit.modal.calendar.add_button')}
              </ModalButton>
            </FlexBox>
          </FlexBox>
          {/* <FlexBox width={'100%'}>
            {searchInput}
          </FlexBox> */}
          {
          showAlreadyUsedModal? 
            <UsedInProjectModal 
              onSubmit={continueAttachment}
              onCancel={cancelAttachment}
              text={t('project_edit.calendar_already_attached')}
            />
          :
          cards?.length > 0 || loading ? (
            <>
              <FlexBox justify='space-between' offsetBottom={32}>
                <FlexBox align='center' direction='row' directionMobile='row' gx={24}>
                  <ModalText>{t('project_edit.modal.calendar.choosed_products')}</ModalText>
                  <ProjectsCount>{selectedCards?.length}</ProjectsCount>
                </FlexBox>
      
                <ProjectSearchBarSorting
                  selectedSorting={sorting}
                  onSortingChange={setSorting}
                  sortingMethods={[1, 20]}
                />
              </FlexBox>
              <ProjectsGridNew k={20} isFixedHeight isLoading={loading} columns={4} mobileColumns={2}>
                {cards?.map((value: any) => {
                  const selected = selectedCards.includes(value?.cardId)
                  const hidePrice = value?.typeCard !== 'product';
                  return (
                    <ShopCard
                      isCalendarImage
                      isModalGood
                      customClick={() => onClick(value?.cardId, selected)}
                      selected={selected}
                      key={value?.cardId}
                      card={value}
                      images={value?.titleImage}
                      price={value?.priceInfo?.realProductPrice}
                      name={value?.name || value?.calendarData?.defaultTitle || ''}
                      hidePrice={hidePrice}
                      usedInProjectName={value.usedInProjectName}
                      selectedComponent={
                        <RingWrapper>
                          <SelectRing active={selected}>
                          <div>
                            {selected && (
                              <svg
                                width="12"
                                height="10"
                                viewBox="0 0 12 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                              4.02557L1 4.85653Z"
                                  fill="#FEFEFE"
                                  stroke="black"
                                />
                              </svg>
                            )}
                          </div>
                          </SelectRing>
                        </RingWrapper>
                      }
                    />
                  )
                  })
                }
  
              </ProjectsGridNew>
              <Pagination
                pages={data?.paging?.pages ?? 0}
                page={Number(currentPage)}
                onPageChange={(page: any) => {
                  setPage(page)
                  scrollTop()
                }}
                isCanLoadMore={currentPage < (data?.paging?.pages ?? 0)}
              />
            </>
          ) : (
            <EmptyModal text={t('project_edit.no_calendars')} />
          )}
        </TagsSearchModalContainer>
      </TagsSearchModalWrapper>
    )
  }
  
  export default CalendarsSelectModal
  import {
    FC,
    useCallback,
    useEffect,
    useMemo, useRef,
    useState
  } from 'react'
  import {
    TagsSearchModalContainer,
    TagsSearchModalWrapper,
    ModalButton,
    ModalText,
    RingWrapper
  } from './styles'
  import { API, Card, PageModel } from '@brg/api'
  import { useProfile } from '@brg/auth'
  import { Colors, FlexBox } from '@brg/ui'
  import {NoProjectWrapper} from "./styles";
  import urlApi from 'shared/actions/urlApi'
  import { useTranslation } from 'react-i18next'
  import { Pagination } from 'shared/components/pagination'
  import { ProjectSearchBarSorting } from 'shared/components/projectsSearchBar/components/projectSearchBarSorting'
  import { CompleteTitle } from '../sendProjects/employStyles'
  import { ProjectsCount } from 'shared/pages/ModeratePages/styles'
  import { ShopCard } from 'shared/pages/Shop/ShopCard'
  import { ProjectsGridNew } from 'shared/components/grids'
  import { ModalSearchWrapper } from '../sendProjects/styles'
  import MobileSearchBar from 'shared/components/MobileSearchBar/MobileSearchBar'
  import { SelectRing } from 'shared/components/projectCard/projectCardNew'
import EmptyModal from './EmptyModal'
import project from 'shared/pages/project'
import UsedInProjectModal from './UsedInProjectModal'
  
  export const useGetCalendars = (
    profileId: string | undefined,
    page: number
  ) => {
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<any>(false)
    const [usedCalendarsData, setUsedCalendarsDate] = useState<any>([])
  
    useEffect(() => {
      if (profileId) {
        urlApi()
          //возвращает проекты, в которых прикреплены календари
          .getUsedCalendarIds()
          .then((r) => {
            setUsedCalendarsDate(r)
          })
      }
    }, [profileId])

    useEffect(() => {
      if (profileId) {
        setLoading(true)
            urlApi()
              .getUserCalendars(page, profileId)
              .then((r) => {
                setData(r)
              })
              .finally(() => setLoading(false))
      }
    }, [profileId, page])
  
    return { data, loading, usedCalendarsData }
  }
  
  interface CalendarsSelectModalProps {
    cardIds: any[]
    projectId: string
    onSubmit: (cards: any[]) => void
  }
  
  const CalendarsSelectModal: FC<CalendarsSelectModalProps> = ({
    onSubmit,
    cardIds,
    projectId
  }) => {
    const { i18n } = useTranslation()
    const [selectedCards, setSelectedCards] = useState<any[]>(cardIds || [])
    const [sorting, setSorting] = useState(1)
    const profile = useProfile();
    const { t } = useTranslation();
    const buttonDisabled = !selectedCards?.length || selectedCards?.length !== 1
    const [currentPage, setPage] = useState(1)
    const [searchText, setSearchText] = useState('');
    const scrollRef = useRef<HTMLDivElement>(null)

    const [showAlreadyUsedModal, setShowAlreadyUsedModal] = useState(false)
  
    const scrollTop = () => {
      if (!scrollRef.current) return
      scrollRef.current?.scrollTo(0, 0)
    }
  
    const onClick = useCallback(
      (cardId: string, selected: boolean) => {
       
        if (selected) {
          setSelectedCards(selectedCards.filter((item) => item !== cardId))
          return
        }
        
        setSelectedCards([cardId])
      },
      [selectedCards]
    )
  
    useEffect(() => {
      if (cardIds?.length) {
        setSelectedCards(cardIds)
      }
    } , [cardIds])
  
    const { data, loading, usedCalendarsData } = useGetCalendars(profile?.accountId, currentPage)
  
    const searchInput = useMemo(() => (
      <ModalSearchWrapper 
        width={'100%'} 
        offsetBottom={24} 
        offsetBottomMobile={16}
      >
        <MobileSearchBar 
          placeholder={t('project_edit.modal.calendar.search_placeholder')} 
          onCustomSearch={(data: string) => setSearchText(data)} 
        />
      </ModalSearchWrapper>
  ), [t])
  
    const cards: any[] = useMemo(() => {
      if (data?.data?.length) {
        return data?.data?.map((card: any) => {
          const projectWithCalendar = usedCalendarsData.find((project: any) => {
            return project.includedCalendarIds?.includes(card.cardId)
          })
          return API.toLang({...card, usedInProjectName: (projectWithCalendar?.title || '')}, i18n.language)
        })
      }
  
      return []
    } , [data, i18n, usedCalendarsData])
  
    const handleAttachClick = useCallback(() => {
      const calendarsUsedInProjects = selectedCards.filter((selectedCardsId: any) => {
        return !!usedCalendarsData.find((project: any) => {
          return project.includedCalendarIds?.includes(selectedCardsId)
        })
      })
      // return
      if (!buttonDisabled) {
        if (calendarsUsedInProjects.length) {
          setShowAlreadyUsedModal(true)
          return
        }
        onSubmit(selectedCards)
      }
    }, [selectedCards, usedCalendarsData])

    const cancelAttachment = useCallback(() => {
      setShowAlreadyUsedModal(false)
    }, [])

    const continueAttachment = useCallback(() => {
      onSubmit(selectedCards)
      setShowAlreadyUsedModal(false)
    }, [selectedCards])
  
    return (
      <TagsSearchModalWrapper autoScroll>
        <TagsSearchModalContainer>
          <FlexBox width={'100%'} widthMobile={'100%'} style={{ position: 'relative' }} justify='space-between' justifyMobile='space-between' direction='row' directionMobile="row">
            <FlexBox width={'100%'} widthMobile={'100%'} justify='space-between' align='center' offsetBottom={48}>
              <CompleteTitle>
                {t('project_edit.modal.calendar.main_title')}
              </CompleteTitle>
              <ModalButton
                onClick={handleAttachClick}
                fill={Colors.galBlack100}
                disabled={!Boolean(selectedCards?.length)}
                width={250}
              >
                {t('project_edit.modal.calendar.add_button')}
              </ModalButton>
            </FlexBox>
          </FlexBox>
          {/* <FlexBox width={'100%'}>
            {searchInput}
          </FlexBox> */}
          {
          showAlreadyUsedModal? 
            <UsedInProjectModal 
              onSubmit={continueAttachment}
              onCancel={cancelAttachment}
              text={t('project_edit.calendar_already_attached')}
            />
          :
          cards?.length > 0 || loading ? (
            <>
              <FlexBox justify='space-between' offsetBottom={32}>
                <FlexBox align='center' direction='row' directionMobile='row' gx={24}>
                  <ModalText>{t('project_edit.modal.calendar.choosed_products')}</ModalText>
                  <ProjectsCount>{selectedCards?.length}</ProjectsCount>
                </FlexBox>
      
                <ProjectSearchBarSorting
                  selectedSorting={sorting}
                  onSortingChange={setSorting}
                  sortingMethods={[1, 20]}
                />
              </FlexBox>
              <ProjectsGridNew k={20} isFixedHeight isLoading={loading} columns={4} mobileColumns={2}>
                {cards?.map((value: any) => {
                  const selected = selectedCards.includes(value?.cardId)
                  const hidePrice = value?.typeCard !== 'product';
                  return (
                    <ShopCard
                      isCalendarImage
                      isModalGood
                      customClick={() => onClick(value?.cardId, selected)}
                      selected={selected}
                      key={value?.cardId}
                      card={value}
                      images={value?.titleImage}
                      price={value?.priceInfo?.realProductPrice}
                      name={value?.name || value?.calendarData?.defaultTitle || ''}
                      hidePrice={hidePrice}
                      usedInProjectName={value.usedInProjectName}
                      selectedComponent={
                        <RingWrapper>
                          <SelectRing active={selected}>
                          <div>
                            {selected && (
                              <svg
                                width="12"
                                height="10"
                                viewBox="0 0 12 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                              4.02557L1 4.85653Z"
                                  fill="#FEFEFE"
                                  stroke="black"
                                />
                              </svg>
                            )}
                          </div>
                          </SelectRing>
                        </RingWrapper>
                      }
                    />
                  )
                  })
                }
  
              </ProjectsGridNew>
              <Pagination
                pages={data?.paging?.pages ?? 0}
                page={Number(currentPage)}
                onPageChange={(page: any) => {
                  setPage(page)
                  scrollTop()
                }}
                isCanLoadMore={currentPage < (data?.paging?.pages ?? 0)}
              />
            </>
          ) : (
            <EmptyModal text={t('project_edit.no_calendars')} />
          )}
        </TagsSearchModalContainer>
      </TagsSearchModalWrapper>
    )
  }
  
  export default CalendarsSelectModal
  